import React, { Component, PropTypes as pt } from 'react';
import { Table, Button, Modal } from 'react-bootstrap';
import { FaTasks } from 'react-icons/lib/fa/';
import update from 'react-addons-update';
import _ from 'underscore';

import AssetListing from '../../../metadata/components/assets/AssetsListing';

class Slates extends Component {
    constructor (props) {
        super(props);

        this.state = {
            edited: false,
            modal: false,
            assigned: [],
            slatesMode: 'video'
        };

        this.transferState = this.transferState.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.cancelModal = this.cancelModal.bind(this);
        this.handleAssignSlate = this.handleAssignSlate.bind(this);
        this.handleSlateModeToggle = this.handleSlateModeToggle.bind(this);
        this.handleRemoveAssassigned = this.handleRemoveAssassigned.bind(this);
        this.handleShift = this.handleShift.bind(this);
        this.handleShiftUp = this.handleShiftUp.bind(this);
        this.handleShiftDown = this.handleShiftDown.bind(this);

        this.renderModal = this.renderModal.bind(this);
        this.renderAssignedTable = this.renderAssignedTable.bind(this);
        this.renderAssignedAsset = this.renderAssignedAsset.bind(this);
        this.commitEdits = this.commitEdits.bind(this);
    }

    toggleModal () {
        this.setState({
            modal: !this.state.modal
        });
    }

    cancelModal () {
        this.setState({
            modal: false,
            assigned: []
        });
    }

    handleSlateModeToggle (ev) {
        const { name } = ev.target;
        this.setState({
            slatesMode: name,
            edited: true,
            assigned: []
        });
    }

    transferState () {
        if (!this.state.edited) {
            this.setState({
                edited: true,
                assigned: this.props.value
            });
        }
    }

    handleAssignSlate (mutedAsset) {
        this.transferState();
        var isAssigned = false,
            assigned = (this.state.edited) ? this.state.assigned : this.props.value,
            updates = [],
            asset = mutedAsset;

        var index;

        for (var i = 0; i < assigned.length; i++) {
            if (assigned[i].assetID == asset.assetID) {
                isAssigned = true;
                index = i; break;
            }
        }

        if (!isAssigned) {
            updates = {$push: [
                _.pick(asset, 'assetID', 'name', 'type', 'fileUrl')
            ]};
        } else {
            updates = {$splice: [[index, 1]]};
        }

        this.setState(function (state) {
            return {
                assigned: update(state.assigned, updates)
            };
        });
    }

    handleRemoveAssassigned (index) {
        this.transferState();
        let self = this
        this.setState(function (state) {
            let clone = _.clone(state.assigned)
            clone.splice(index, 1)
            self.props.storeEdits(clone)
            return {
                assigned: clone
            };
        });
    }

    handleShift (direction, index) {
        this.transferState();
        var assigned = this.state.edited ?
            this.state.assigned :
            this.props.value;
        var replaceAt = (direction == 'up') ? (index - 1) : (index + 1);
        var hold = assigned[replaceAt];
        var replacement = assigned[index];

        var updates = [].concat(assigned);
        updates.splice(replaceAt, 1, replacement);
        updates.splice(index, 1, hold);
        this.setState(function (state) {
            return {
                assigned: update(state.assigned, {$set: updates})
            };
        });
    }

    handleShiftUp (index) {
        return this.handleShift('up', index);
    }

    handleShiftDown (index) {
        return this.handleShift('down', index);
    }

    commitEdits (ev) {
        ev && ev.preventDefault();
        this.toggleModal();
        this.props.storeEdits(this.state.assigned)
    }

    render () {
        const { renderModal, renderAssignedTable } = this;
        const noAssetMsg = "You have 0 available assets to assign, save your player preference and continue to the Global Media library manager to upload content that can be used for \"Slates\"."
        return (<div id={'slates-' + this.props.preferenceName} className="row">
            <div className="col-xs-12">
                <button
                    title={this.props.assets.data ? null : noAssetMsg}
                    className={this.props.assets.data ? "btn btn-primary" : "btn btn-danger"}
                    disabled={!this.props.assets.data}
                    onClick={this.toggleModal}
                >
                    <FaTasks/> Assign Slates
                </button>
                {this.props.assets.data ? null : <span style={{marginLeft:'0.5rem'}}>{noAssetMsg}</span>}
            </div>

            {renderAssignedTable()}
            {renderModal()}
        </div>);
    }

    renderModal () {
        return (<Modal
            bsSize="large" animation={false} onHide={this.toggleModal} show={this.state.modal}>
            <Modal.Header>
                Assign Slates from your Global Media Library
            </Modal.Header>
            <Modal.Body>
                <AssetListing
                    slatesMode={this.state.slatesMode}
                    mode="assign-slates"
                    toggleSlateMode={this.handleSlateModeToggle}
                    clearAssigned={this.handleClearAssigned}
                    assigned={this.state.edited ? this.state.assigned : this.props.value}
                    assignSlate={this.handleAssignSlate}
                    isResolving={this.props.assets.isResolving}
                    data={this.props.assets.data}/>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={this.toggleModal} bsStyle="link">Cancel</Button>
                <button className="btn btn-success" onClick={this.commitEdits}>
                    <i className="fa fa-save" /> Save
                </button>
            </Modal.Footer>
        </Modal>);
    }

    renderAssignedTable () {
        if (!this.state.modal) {

            var content;
            const assigned = (this.state.edited) ?
                this.state.assigned :
                this.props.value;

            if (!assigned.length) {
                content = (<blockquote><em>No Media Assigned.</em></blockquote>);
            } else {
                content = (<Table responsive bordered striped condensed>
                    <thead>
                        <tr>
                            <th colSpan="4">
                                <strong>Assigned Media</strong>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {_(assigned).map(function (asset, index) {
                            return this.renderAssignedAsset(asset, index);
                        }, this)}
                    </tbody>
                </Table>);
            }

            return (<div className="col-xs-12">{content}</div>);
        }
    }

    renderAssignedAsset (asset, index) {
        const assigned = (this.state.edited) ?
            this.state.assigned :
            this.props.value;

        return (<tr key={asset.assetID + '-' + index}>
            <td className="col-sm-1"><strong>{index + 1}</strong></td>
            <td className="col-sm-1">
                <button type="button"
                    className="btn btn-default"
                    onClick={this.handleRemoveAssassigned.bind(null, index)}>
                        Remove
                </button>
            </td>
            <td className="col-sm-2">
                <div className="btn-group" role="group" aria-label="...">
                    <button type="button"
                        disabled={assigned.length === 0 || (index == 0)}
                        className="btn btn-default"
                        onClick={ev => this.handleShiftUp(index)}
                    >
                        <i className="fa fa-arrow-up" />
                    </button>

                    <button type="button"
                        disabled={assigned.length === 0 || (index == assigned.length - 1)}
                        className="btn btn-success"
                        onClick={ev => this.handleShiftDown(index)}
                    >
                        <i className="fa fa-arrow-down" />
                    </button>
                </div>
            </td>

            <td className="col-sm-8">
                <a href={asset.fileUrl} target="_blank" rel="noopener noreferrer">
                    {asset.name}
                </a>
            </td>
        </tr>);
    }
}

Slates.propTypes = {};

export default Slates;
